import React from 'react'
import { AppContext } from '../context'
import Navbar from './ui/Navbar'
import Logo from '../assets/img/brand/explore-w-logo-blue-large@2x.png'

interface Query {
  [key: string]: any
  postLink?: string
  lng?: number
  lat?: number
  zoom?: number
  postId?: string
  postAuthorId?: string
}

const Explore: React.FC<any> = ({ match }) => {
  const { isAuthenticated } = React.useContext(AppContext)

  const urlParts = window.location.href.split('/')
  const isLegacyFormat = urlParts.length > 7
  let { lng, lat, zoom, postId, authorId: postAuthorId } = match.params

  const query: Query = {}

  if (!isLegacyFormat) {
    // Get query parameters from the URL
    const urlSearchParams = new URLSearchParams(window.location.search)

    const params = Object.fromEntries(urlSearchParams.entries())

    if (params.postLink) {
      query.postLink = params.postLink
    }
  } else {
    query.lng =
      lng !== null && lng !== undefined && lng !== ''
        ? parseFloat(lng).toFixed(6)
        : lng
    query.lat =
      lat !== null && lat !== undefined && lat !== ''
        ? parseFloat(lat).toFixed(6)
        : lat
    query.zoom = zoom
    query.postId = postId
    query.postAuthorId = postAuthorId
  }

  // Convert query to string
  const queryStr = Object.keys(query)
    .map(key => `${key}=${query[key]}`)
    .join('&')

  const loginRedirectUrl = `${process.env.REACT_APP_EXPLORE_URL}?${queryStr}`
  const registerRedirectUrl = `${process.env.REACT_APP_ID_SERVER_URL}Account/Register?ReturnUrl=${process.env.REACT_APP_EXPLORE_URL}?${queryStr}`

  if (isAuthenticated !== null && isAuthenticated) {
    window.location.href = loginRedirectUrl
  }

  return (
    <>
      <Navbar />
      {isAuthenticated === null ||
        (!isAuthenticated && (
          <div id="preview-page-container">
            <div className="col-12 col-md-4 col-xl-3">
              <div>
                <img src={Logo} alt="Explore with Imray logo" />
                <h2>Welcome to Explore with Imray</h2>
                <p>
                  Login or create a free account to explore sailing and social
                  content.
                </p>
                <a className="btn btn-primary" href={loginRedirectUrl}>
                  Sign in
                </a>
                <a className="btn btn-secondary" href={registerRedirectUrl}>
                  Create an Imray account
                </a>
              </div>
            </div>
          </div>
        ))}
    </>
  )
}
export default Explore
